import { ContractStartYear } from "@/types/productionPoint";
import { Contract } from "@/types/contract";
import dayjs from "dayjs";
import { isHighProductionContract, isOverFlowContract } from "./product";

const endOf2025 = "2025-12-31";

export const showContractStartYear = (code: string | null, codeSecondary: string | null, installedPower: number | null) => {
  if (!code || !codeSecondary || !installedPower) {
    return false;
  }
  const currentYear = dayjs().get("year");
  const isPriceListPublished = dayjs().isBetween(`${currentYear}-08-31`, `${currentYear}-12-31`, "date", "[]");
  const isHighProductionIn2025 = dayjs().isBefore(dayjs(endOf2025)) && installedPower > 50;

  return isPriceListPublished && code !== codeSecondary && !isHighProductionIn2025;
};

export const isDateAfterDefinedDate = (): boolean => {
  const currentYear = dayjs().get("year");
  return dayjs().isAfter(dayjs(`${currentYear}-11-18`));
};

export const getContractStartYear = (contract: Contract): ContractStartYear => {
  const startYear = contract.contractDetails?.contractStartYear;

  if (isDateAfterDefinedDate()) {
    return "next";
  }

  if (
    startYear === null ||
    startYear === new Date().getFullYear() ||
    contract.supplyPoint.code === contract.supplyPoint.codeSecondary
  ) {
    return "current";
  }
  return "next";
};

export const getContractStartYearNumber = (contractStartYear: ContractStartYear, installedPower: number | null) => {
  const currentYear = new Date().getFullYear();
  if (isDateAfterDefinedDate()) {
    return currentYear + 1;
  }

  const isBeforeEndOf2025 = dayjs().isBefore(dayjs(endOf2025));
  if (installedPower! > 50 && isBeforeEndOf2025) {
    return currentYear + 1;
  }
  const isNewPriceListPublished = dayjs().isBefore(`${currentYear}-08-31`);
  if (isNewPriceListPublished && installedPower! <= 50) {
    return currentYear;
  }
  return contractStartYear === "current" ? currentYear : currentYear + 1;
};

export const changeProductId = (productId: string | null, year: number, installedPower: number | null) => {
  if (installedPower! > 50 && productId?.match(/_20\d{2}$/) && !isOverFlowContract(productId)) {
    const isBeforeEndOf2025 = dayjs().isBefore(dayjs(endOf2025));
    if (isBeforeEndOf2025) {
      if (productId.includes("_NAD50_")) {
        return productId.substring(0, productId.length - 4).concat("2026");
      }
      const switchedProductId = productId.substring(0, productId.length - 5) + "_NAD50_";
      return switchedProductId.concat("2026");
    }

    if (isHighProductionContract(productId)) {
      return productId.substring(0, productId.length - 4).concat(year.toString());
    }
    const switchedProductId = productId.substring(0, productId.length - 5) + "_NAD50_";
    return switchedProductId.concat(year.toString());
  }

  if (installedPower! <= 50 && productId?.match(/_20\d{2}$/) && !isOverFlowContract(productId)) {
    const isBeforeNewPriceList = dayjs().isBefore(`2025-09-09`);

    const switchedProductId = productId.replace("_NAD50_", "_");
    if (isBeforeNewPriceList) {
      return switchedProductId.substring(0, switchedProductId.length - 4) + "2025";
    }
    return switchedProductId.substring(0, switchedProductId.length - 4) + year.toString();
  }

  if (productId?.match(/_20\d{2}$/)) {
    return productId.substring(0, productId.length - 4) + year.toString();
  }
  return productId;
};
